export default (str: string) => {
    let output: undefined | AnonymousObject | AnonymousObject[];
    try {
        output = JSON.parse(str);
    } catch (error) {
        console.error('safe-parse', error);
    }
    return output;
};
